import React, { useContext, useEffect, useState, useMemo} from 'react';
import './index.scss';
import { ThemeContext } from '../../store/ThemeProvider';
import intl from 'react-intl-universal';
import { inject, observer } from 'mobx-react';
import RootStore from '../../store/RootStore';
import { getPendantColor } from '../../utils/color';
import chroma from 'chroma-js';
import { isIphoneX } from '../../utils/util';

interface IAvatar {
  src: string;
}
const Avatar = (props: IAvatar) => (
  <img className="avatar" src={props.src} alt={''} />
);

interface ILeadingPage {
  bg: string;
  // avatars?: string[];
  showBar?: boolean;
  skip?: () => void;
  duration?: number;
  barColor?: string;
  opacity?: number;
  autoPlay?: boolean;
}

const BackgroundImage = (props:{
  bg:string
})=>{
  return useMemo(()=>{
    return <div
      key="bg"
      className="main-bg"
      style={{
        backgroundImage: `url(${props.bg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'top center'
      }}
    />
  }, [props.bg]);
};

const BottomAvatar = inject('rootStore')(observer((props:{
  rootStore?:RootStore;
  barColor?:string;
  barTextColor?:string;
  opacity?: number;
})=>{
  const {galleryStore, wxuserStore} = props.rootStore!;
  const [visited, setVisited] = useState([] as string[]);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    galleryStore.getLinkLatest(window.pageDetail.link_id).then(dt => {
      // 始终把自己放在最前面
      const { user } = wxuserStore;

      let list = (dt.data.items || [])
        .map((it: any) => {
          if (it && it.photo != user.photo && it.nickname != user.nickname)
            return it.photo;
          return null;
        })
        .filter(Boolean);

      if (user.photo) {
        list.unshift(user.photo);
      }

      setVisited(list);
      setTotal(Math.max(list.length, dt.data.total));
    });
  }, []);

  // 和产品讨论最终最多显示10个；同时不需要最后的more-avatar了
  const MAX_AVATAR_LEN = 10;
  const filteredAvatars = visited && visited.length ? visited.filter(Boolean) : [];
  const shownAvatars = filteredAvatars.slice(0, MAX_AVATAR_LEN);

  return <div
    className="leading-bottom animate__fadeInUp animate__animated animate__delay-1s"
    style={{
      paddingBottom: isIphoneX() ? (22 + 14) : 14,
      backgroundColor: chroma(props.barColor || '#ffffff')
        .alpha(
          typeof props.opacity != 'undefined' ? props.opacity / 100 : 1
        )
        .css()
    }}
  >
    <div className="row1">
      <div className="avatar-list">
        {shownAvatars.map((avatar, index) => (
          <Avatar src={avatar} key={index} />
        ))}
      </div>
    </div>
    <div className={'people-see-row'}>
      {/*为了英文观感，多加一个空格，这个没法在翻译上面弄，会被过滤掉*/}
      <span style={{ color: props.barTextColor, marginLeft:20}}>{total}</span>&nbsp;
      <span style={{ color: props.barTextColor }}>
        {intl.get('People see', { num: total })}
      </span>
    </div>
  </div>
}));

const LeadingPage = function(props: ILeadingPage) {
  const { componentColor, h1Color, h2Color } = useContext(ThemeContext);
  const [countDown, setCountDown] = useState((props.duration || 0) / 1000);
  const { backgroundColor } = useContext(ThemeContext);
  const [pendantBgColor, pendantIconColor] = getPendantColor(props.barColor || backgroundColor);
  const [barBgColor, barTextColor] = getPendantColor(
    props.barColor || '#ffffff'
  );
  useEffect(() => {
    const timer = setInterval(() => {
      setCountDown(pre => {
        if (pre > 0) {
          return pre - 1;
        }
        clearInterval(timer);
        return pre;
      });
      return () => {
        clearInterval(timer);
      };
    }, 1000);
  }, [props.duration]);

  return (
    <div className="leading-page" onClick={props.skip}>
      <BackgroundImage bg={props.bg} />
      {props.showBar && Number(window.configDetail!.active_on) ? <BottomAvatar
        barColor={props.barColor}
        barTextColor={barTextColor}
        opacity={props.opacity}
      /> : null}
      {props.autoPlay && (
        <div
          className="count-down-timer"
          style={{ background: props.barColor, color: barTextColor }}
        >
          {countDown} {intl.get('Skip')}
        </div>
      )}
    </div>
  );
};

export default LeadingPage;
